import { Component, Input } from '@angular/core';
import { BBInvitations, BBInvitationsDefaultValues } from '../bb-invitation';
import { UserService } from 'src/app/services/user.service';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';

@Component({
    selector: 'app-bb-invitation-form',
    templateUrl: './bb-invitation-form.component.html',
    styleUrls: ['./bb-invitation-form.component.scss'],
    standalone: false
})
export class BbInvitationFormComponent {
  @Input() bbinvitation: BBInvitations = BBInvitationsDefaultValues();
  @Input() isSubmitted: boolean = false;
  bbcoacheduser: any[] = [];
  program: any[] = [];

  constructor(private _userservice: UserService,
              private _bbinvitationservice: BbInvitationService,
              private appprogservice: ApplicationProgramsService) {
  }

  ngOnInit() {
    this._userservice.getCoachedUsers().subscribe({
      next:(response) => {
        this.bbcoacheduser = response;
        this._bbinvitationservice.getPrefilledDataForCoach().subscribe({
          next:(response) => {
            this.bbinvitation.coachId = response.coachId;
            this.bbinvitation.isCoach = response.isCoach;
          }
        });
      }
    });

    this.appprogservice.getCoachedPrograms().subscribe({
      next:(resp) => {
        this.program = resp;
      }
    });
  }

  chkLinkExpiryDate(): boolean {
    if (this.bbinvitation.linkExpiryDate != null
      && new Date(this.bbinvitation.linkExpiryDate) > new Date()
      && new Date(this.bbinvitation.linkExpiryDate) > new Date(this.bbinvitation.programStartDate!)) {
      return true;
    }
    else {
      return false;
    }
  }

  validateReqFileds(): boolean {
    let flag = true;

    if (this.bbinvitation.email == '') {
      flag = false;
    }

    if (this.bbinvitation.coachId == 0) {
      flag = false;
    }

    if (this.bbinvitation.program == 0) {
      flag = false;
    }

    if (this.bbinvitation.languageId == null || this.bbinvitation.languageId == 0) {
      flag = false;
    }

    if (this.bbinvitation.programStartDate == null) {
      flag = false;
    }

    if (!this.chkLinkExpiryDate()) {
      flag = false;
    }

    return flag;
  }

  setExpectedExpiryDate(event: any) {
    const selectedDate = event.value;

    if (selectedDate) {
      const expiryDate = new Date(selectedDate);
      expiryDate.setDate(expiryDate.getDate() + 21);
      this.bbinvitation.linkExpiryDate = expiryDate
    }
  }
}
